'use client'

import { useAuthorization } from '@entities/authentication'
import { type ReactNode, useEffect } from 'react'

import { resetUser, setUser } from '@podo-app/analytics/react'

export const AnalyticsUserProvider = ({ children }: { children: ReactNode }) => {
  const authState = useAuthorization()

  useEffect(() => {
    if (authState.isAuthorized && authState.uid) {
      setUser({ userId: String(authState.uid) })
    } else {
      resetUser()
    }
  }, [authState.isAuthorized, authState.uid])

  return <>{children}</>
}
